export default __webpack_public_path__ + "static/media/09.001aacf9.jpg";